var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: 'combobox', base: 'string', prototype: {
    element_selector: '.combobox input, input.combobox, input[list]',

    search_from_start: true,
    case_sensitive: false,

    init: function (params) {
      xP.controls.combobox.base.init.apply(this, arguments);

      var $list = $(
        "select#" + xP.taint_css(this.$element.attr('list') + '')
      );

      if ($list[0]) {
        $list.addClass('combolist');

        var list = xP($list).first(),
          that = this;

        that.list = list;

        this.change(function () {
          if (list._param('do_not_filter')) {
            return;
          }

          var value = that.val();

          if (value != '' && value != undefined) {
            list.disable(
              false,
              {
                values: [
                  new RegExp(
                    (that.search_from_start ? '^' : '')
                    + xP.taint_css(value),
                    that.case_sensitive ? '' : 'i'
                  )
                ]
              }
            );
          } else {
            list.disable(false, {values: [/.?/]});
          }

          xP.after(function () {
            list.$element[0].selectedIndex = 8888;

            if (list.$element[0].options.length === 0) {
              list.hide();
            } else if (value) {
              var first_value = list.$element[0].options[0].value;

              if (!that.case_sensitive) {
                value = value.toLowerCase();
                first_value = first_value.toLowerCase();
              }

              if (value === first_value) {
                list.$element[0].selectedIndex = 0;
                list.$element.change();
              }
            }

            if (that.$element.is(':focus')) {
              list.show();
            }
            list._param('do_not_show', false);
          });
        });

        this.$element
          .bind('focus', function (ev) {
            list._param('do_not_filter', false);
            list.show();
          })
          .bind('blur', function (ev) {
            list.hide();
          })
          .bind('keydown', function (ev) {
            if (ev.keyCode === 38 || ev.keyCode === 40) {
              // up & down.
              list._param('do_not_filter', true);
              list._param('do_not_hide', true);
              list.show();
              list.$element.focus();
              if (list.$element[0].selectedIndex === -1) {
                list.$element[0].selectedIndex = 0;
                list.$element.change();
              }
            } else if (ev.keyCode === 13 || ev.keyCode === 27) {
              list.hide();
            }
          });

        list.$element
          .bind('blur', function (ev) {
            list._param('do_not_hide', false);
            list.hide();
          })
          .bind('change', function (ev) {
            that.val(list.val());
          })
          .bind('mousedown', function (ev) {
            list._param('do_not_hide', true);
          })
          .bind('click keyup', function (ev) {
            if (
              ev.type === 'click'
              || ev.keyCode === 13
              || ev.keyCode === 27
            ) {
              list._param('do_not_filter', false);
              list._param('do_not_show', true);
              that.val(list.val());
              that.$element.focus();
              list.hide();
            }
          });
      }
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/combobox.js
 ** module id = 11
 ** module chunks = 0
 **/